import React from 'react'
import { Ico } from '@/components/icons'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

const Documents = () => {
  const { t } = useLang()
  const d = t.acct.manage.documents

  return (
    <div className="app-shell">
      <Sidebar active="docs"/>
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.documents]}/>
        <div className="content">
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "end", marginBottom: 20 }}>
            <div>
              <div className="kicker accent" style={{ marginBottom: 10 }}>◆ 284 PHOTOS · 23 DOCS</div>
              <h1 className="h-display" style={{ fontSize: 36, margin: 0 }}>
                {d.title_1} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{d.title_2}</span>
              </h1>
              <p style={{ fontSize: 14, color: "var(--muted)", marginTop: 6, maxWidth: 500 }}>
                {d.blurb}
              </p>
            </div>
            <button className="btn btn-primary" style={{ padding: "10px 16px", fontSize: 13 }}><Ico.plus/> {d.upload}</button>
          </div>

          {/* Search/filter pills */}
          <div style={{ display: "flex", gap: 6, marginBottom: 18, alignItems: "center", flexWrap: "wrap" }}>
            <div style={{ position: "relative", marginRight: 6 }}>
              <input className="auth-input" placeholder={d.search_ph} style={{ padding: "9px 14px 9px 34px", fontSize: 13, width: 280, borderRadius: 999 }}/>
              <span style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", color: "var(--muted)" }}><Ico.search/></span>
            </div>
            {[d.all_tab, d.warranties, d.receipts, d.photos, d.inspections].map((f, i) => (
              <div key={f} className={`checkbox-pill ${i === 0 ? "on" : ""}`} style={{ fontSize: 12, padding: "6px 12px" }}>{f}</div>
            ))}
          </div>

          <div style={{ display: "grid", gridTemplateColumns: "1.1fr 1fr", gap: 18 }}>
            {/* Docs list */}
            <div className="tile" style={{ padding: 0, overflow: "hidden" }}>
              <div style={{ padding: "16px 20px", borderBottom: "1px solid var(--line)", display: "flex", justifyContent: "space-between" }}>
                <h3 className="h-display" style={{ fontSize: 18, margin: 0 }}>{d.warranties_section}</h3>
                <span className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>23 {d.all_tab.toUpperCase()}</span>
              </div>
              {d.docs.map((doc, i) => (
                <div key={doc.name} style={{ display: "grid", gridTemplateColumns: "auto 1fr auto auto", padding: "14px 20px", borderTop: i > 0 ? "1px solid var(--line)" : "none", gap: 14, alignItems: "center" }}>
                  <div style={{ width: 38, height: 46, borderRadius: 6, background: "var(--cream-2)", display: "flex", alignItems: "center", justifyContent: "center", color: doc.color, border: `1px solid ${doc.color}33` }}>
                    <Ico.doc width="20" height="20"/>
                  </div>
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 600 }}>{doc.name}</div>
                    <div style={{ display: "flex", gap: 8, marginTop: 3 }}>
                      <span style={{ fontFamily: "'Geist Mono', monospace", fontSize: 9, color: doc.color, padding: "1px 5px", borderRadius: 3, background: doc.color + "22" }}>{doc.t}</span>
                      <span className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>{d.from_label} {doc.date.toUpperCase()}</span>
                      {doc.exp !== "—" && <span className="font-mono" style={{ fontSize: 10, color: "var(--muted)" }}>· {d.exp_label} {doc.exp.toUpperCase()}</span>}
                    </div>
                  </div>
                  <button className="icon-btn" style={{ width: 30, height: 30 }}><Ico.eye/></button>
                  <button className="icon-btn" style={{ width: 30, height: 30 }}><Ico.download/></button>
                </div>
              ))}
            </div>

            {/* Photo album */}
            <div className="tile" style={{ padding: 22 }}>
              <div style={{ display: "flex", justifyContent: "space-between", marginBottom: 14 }}>
                <h3 className="h-display" style={{ fontSize: 18, margin: 0 }}>{d.before_after}</h3>
                <a href="#" className="font-mono" style={{ fontSize: 10, color: "var(--terracotta)", textDecoration: "none" }}>{d.grid_view}</a>
              </div>
              <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: 8 }}>
                {d.photo_cards.map((ph, i) => (
                  <div key={i} className="photo" style={{ aspectRatio: 1, padding: 10, display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
                    <span className="font-mono" style={{ fontSize: 9, color: "var(--cocoa)", background: "rgba(245,239,230,0.85)", padding: "2px 6px", borderRadius: 4, alignSelf: "start" }}>{ph.date.toUpperCase()}</span>
                    <div style={{ background: "rgba(42,31,24,0.85)", color: "var(--cream)", padding: "6px 8px", borderRadius: 6 }}>
                      <div className="font-mono" style={{ fontSize: 9, color: "#E68A5C" }}>{ph.room.toUpperCase()}</div>
                      <div style={{ fontSize: 11, fontWeight: 600, marginTop: 1 }}>{ph.label}</div>
                      <div className="font-mono" style={{ fontSize: 9, color: "rgba(245,239,230,0.6)" }}>{ph.count} {d.photos_label}</div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default function ManageDocumentsPage() {
  return <Documents />
}
